import React from 'react';
import {
  Row,
  Col,
  Card,
  Typography,
  Popover
} from 'antd';
import { useSelector } from 'react-redux';
import { safeExtractFromObject } from '../helpers/helpers';
import colors from '../constants/Colors';

const { Text, } = Typography;

const rowStyle = {width:'100%',lineHeight:'13px'}
const valueStyle = {
  fontFamily:'raleway-semibold',
  fontSize:10,
  color:colors.ONTRACCR_BLACK,
  width:'100%',
}
export default function UserWeekView({
  tasks,
  days,
  userId,
  onClick
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  return (
    <Popover content={'Click to see the whole pay period'} title='This is the current week' trigger="hover">
      <Card 
        hoverable={true}
        onClick={onClick ? (e) => {
          e.stopPropagation();
          onClick(tasks,userId);
        } : null}
        bodyStyle={{
          padding:2,
        }}
        style={{
          borderRadius:5,
          backgroundColor: hasRedesign ? colors.BLUE_100 : colors.ONTRACCR_MODAL_BACKGROUND_YELLOW,
          padding:'4px 4px 4px 4px',
          marginLeft: '20px',
          width:70
      }}>
        <DayRow day="Mon" value={days[0]} />
        <DayRow day="Tue" value={days[1]} />
        <DayRow day="Wed" value={days[2]} />
        <DayRow day="Thu" value={days[3]} />
        <DayRow day="Fri" value={days[4]} />
        <DayRow day="Sat" value={days[5]} />
        <DayRow day="Sun" value={days[6]} />
      </Card>
    </Popover>
  );
}

function DayRow({ day, value }) {
  return (
    <Row justify="space-between">
      <Col span={12}>
        <Row style={rowStyle}>
          <Text style={valueStyle}>
            {day}
          </Text>
        </Row>
      </Col>
      <Col span={12} style={{ textAlign: 'right' }}>
        <Row style={rowStyle}>
          <Text style={valueStyle}>
            {value}
          </Text>
        </Row>
      </Col>
    </Row>
  );
}
